import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { emailSendErrorInterceptor } from './app/http/email-send-error.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';

import { environment } from './environments/environment';
import { MsalModule, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { importProvidersFrom } from '@angular/core';

async function main() {
  // ✅ Create and initialize MSAL instance
  const msalInstance = new PublicClientApplication({
    auth: {
      clientId: 'b49dd0c0-fee3-4c95-a2c8-1407c9306b44',
      authority: 'https://login.microsoftonline.com/453e97a8-e451-4753-b5e8-b02a689ff26e',
      redirectUri: environment.appOrigin,
    }
  });

  await msalInstance.initialize(); // 🔑 Must initialize before usage


  const interceptorConfig: MsalInterceptorConfiguration = {
    interactionType: InteractionType.Popup,
    protectedResourceMap: new Map([
      ['https://graph.microsoft.com/v1.0/me', ['user.read']]
    ])
  };

  await bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(routes),
      provideHttpClient(withInterceptors([emailSendErrorInterceptor])),
      provideAnimations(),
      importProvidersFrom(
        MsalModule.forRoot(
          msalInstance,
          { interactionType: InteractionType.Popup},
          interceptorConfig
        )
      )
    ]
  });
}

main();
